import { useState } from 'react';
import {
  formatDateShort,
  formatMonth,
} from '@purple-start-registration/common/dates';
import { strings } from '@purple-start-registration/common/localization';

import { formatHTML } from '../../../common/price';

function listSessions(month, sessions) {
  const matchingSessions = sessions.filter((session) => {
    return session.date.getUTCMonth() === month.date.getUTCMonth();
  });

  return matchingSessions;
}

export function SelectionMonth({ config, language, onChange }) {
  const { months, sessions, settings } = config;

  const [checkedState, setCheckedState] = useState(
    new Array(sessions.length).fill(false)
  );

  const notifyParent = (state) => {
    if (onChange) {
      onChange(
        state
          .map((selected, index) => selected && months[index])
          .filter((session) => !!session)
      );
    }
  };

  const handleOnChange = (position) => {
    const state = checkedState.map((item, index) =>
      index === position ? !item : item
    );
    setCheckedState(state);
    notifyParent(state);
  };

  const handleCheckAll = (e) => {
    e.preventDefault();

    const state = sessions.map((s) => true);
    setCheckedState(state);
    notifyParent(state);
  };

  return (
    <fieldset>
      <div>
        <legend className="text-base font-medium text-gray-900">
          {strings.sessionsByMonthTitle}
        </legend>
        <p
          className="mt-1 text-sm text-gray-700"
          dangerouslySetInnerHTML={{
            __html: strings.formatString(
              strings.sessionsByMonthDescription,
              formatHTML(settings.session_price),
              settings.discount_min_months,
              formatHTML(settings.discounted_month_session_price)
            ),
          }}
        />
      </div>
      <div className="mt-4 space-y-4">
        {months.map((month, index) => {
          const availableSessions = listSessions(month, sessions).filter(
            (session) => !session.full
          );
          if (availableSessions.length === 0) {
            return <div key={month.dateISO}></div>;
          }

          return (
            <div key={month.dateISO} className="relative flex items-start">
              <div className="flex items-center h-5">
                <input
                  id={month.dateISO}
                  type="checkbox"
                  name={month.dateISO}
                  checked={checkedState[index]}
                  className="focus:ring-purple-500 h-4 w-4 text-purple-600 border-gray-300 rounded"
                  onChange={() => handleOnChange(index)}
                />
              </div>
              <div className="ml-3 text-sm">
                <label htmlFor={month.dateISO} className="text-gray-700">
                  {formatMonth(month.date, language)}
                  <p className="text-gray-500">
                    {availableSessions
                      .map((session) => formatDateShort(session.date, language))
                      .join(', ')}
                  </p>
                </label>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-5">
        <button
          type="submit"
          onClick={handleCheckAll}
          className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500"
        >
          {strings.sessionsByMonthSelect}
        </button>
      </div>
    </fieldset>
  );
}
